import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
const Faq = () => {
  return (
    <div className="teams" id="faq">
      <div className="faqs">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h6>FAQs</h6>
                <h4>Frequently Asked Questions</h4>
                <p>
                  If you can't find your question here, please feel free to
                  &nbsp;{" "}
                  <Link to="" style={{ color: "#fff" }}>
                    contact us.
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 pt-5 pt-lg-0">
              <Accordion className="faq-accordion row">
                <div className="col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>What is a DAO?</Accordion.Header>
                    <Accordion.Body>
                      <p>
                        A DAO (Decentralized Autonomous Organization) in the
                        context of Pocket Ventures' $POCKET token is a
                        community-driven investment structure that allows retail
                        token holders to participate by proxy in Pocket
                        Venture's deal flow with institutional-grade governance
                        and transparency.
                      </p>
                      <br />
                      <p>
                        Through tokenized fractional ownership, investors access
                        high-quality early-stage startup opportunities with as
                        little as $5K, bypassing our traditional $1M minimum.
                        DAO members hold voting rights, influence investment
                        decisions, and create network-driven deal flow.
                      </p>
                      <br />
                      <p>
                        The DAO ensures portfolio transparency by leveraging
                        Smart Wallet Authentication, providing real-time
                        insights into SDG/CCF impact metrics. By combining deal
                        discipline with decentralized governance, $POCKET
                        democratizes access to community-focused funding
                        opportunities, creating an inclusive and scalable
                        investment ecosystem.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="offset-lg-1 col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Who is Pocket Ventures?</Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Pocket Ventures is a mission-driven investment platform
                        dedicated to democratizing venture capital by making
                        high-impact startup investing accessible to a broader
                        audience. Through $POCKET tokenization, it lowers its
                        traditional $1M minimum investment to just $5K, allowing
                        retail investors, angel investors, and fund managers to
                        influence their choices in early-stage opportunities
                        that align with social impact goals (SDG/CCF metrics).
                        There is no capital outcome as the goal. The goal is
                        social benefit. Consider $POCKET token swag.
                      </p>
                      <br />
                      <p>
                        Pocket Ventures operates at the intersection of
                        community capital and institutional-grade investing,
                        offering DAO governance for investor participation in
                        deal selection while ensuring transparency and impact
                        measurement through Smart Wallet Authentication. Its
                        model bridges a gap between social good and people
                        seeking community impact and traditional venture model
                        in a crypto-native workflow to modernize and expand its
                        public benefit deal flow.
                      </p>
                      <br />
                      <p>
                        Additionally, Pocket is a nonprofit, with wholly owned
                        LLC, and is exclusively focused on advancing equitable
                        economic growth by supporting program-related
                        investments (PRI) that empower underserved communities,
                        foster entrepreneurship, and drive sustainable
                        development. By combining blockchain-powered
                        transparency, decentralized governance, and professional
                        investment oversight, Pocket Ventures is revolutionizing
                        access to high-quality, socially responsible venture
                        opportunities.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      What is Social Impact Investing with us?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Community-Focused Social Impact Investing at Pocket
                        Ventures is a mission-driven approach that channels
                        capital into local businesses, infrastructure, and
                        technologies that strengthen communities, promote
                        economic inclusion, and drive sustainable development.
                        Unlike traditional venture capital, which prioritizes
                        rapid growth and high returns for a select few, Pocket
                        Ventures prioritizes community resilience, democratic
                        control, and long-term sustainability.
                      </p>
                      <br />
                      <p>
                        <b> How It Works:</b> Investing in Local Innovation –
                        Pocket Ventures backs startups and projects that provide
                        tangible, scalable solutions for communities, such as
                        microgrids, urban farming, local fintech, and workforce
                        development tools.
                      </p>{" "}
                      <br />
                      <p>
                        Prioritizing Economic Inclusion – Investments focus on
                        historically underserved communities, ensuring that
                        capital stays within the local economy rather than being
                        extracted by outside corporations.
                      </p>
                      <br />
                      <p>
                        Sustainability & Impact – Every investment aligns with
                        the UN Sustainable Development Goals (SDGs) and
                        Community Capital Framework, ensuring measurable social,
                        economic, and environmental benefits.
                      </p>
                      <br />
                      <p>
                        Empowering Ownership & Decision-Making – Through DAO
                        governance and community participation, investors and
                        local stakeholders have a say in investment decisions,
                        fostering shared wealth creation rather than wealth
                        concentration.
                      </p>
                      <br />
                      <p>
                        Measurable & Transparent Returns – Pocket Ventures
                        leverages Smart Wallet Authentication and blockchain
                        transparency to provide insights on job creation, carbon
                        reduction, and economic growth.
                      </p>{" "}
                      <br />
                      <p>
                        By bridging community impact with not-for-profit venture
                        investing, Pocket Ventures empowers local economies,
                        redefines Main Street revitalization, and democratizes
                        access to capital, ensuring that growth benefits all,
                        not just a privileged few​
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="offset-lg-1 col-lg-5 col-sm-12">
                  <Accordion.Item eventKey="7">
                    <Accordion.Header>Can I sell my $Pocket?</Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Yes, you can sell your $POCKET token like any other
                        crypto token—there are no restrictions on
                        transferability. However, $POCKET is not designed as a
                        tradable security or for speculative trading on DEXes or
                        other exchanges.
                      </p>
                      <br />
                      <p>
                        Think of $POCKET as a ticket to the dance—it grants
                        exclusive access to venture deal flow, DAO governance,
                        and community-driven investment decisions. Holding
                        $POCKET lets you participate in funding high-impact
                        startups and influence investment outcomes, but it’s not
                        structured for active trading or liquidity events.
                      </p>
                      <br />
                      <p>
                        That said, because it’s a crypto token, it can be
                        transferred or sold like any other digital asset. Just
                        don’t expect it to function like equity or an investment
                        vehicle with an implied financial return. The value of
                        $POCKET lies in access, governance, and community
                        participation, not speculation.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
